import type { TOC } from '@ember/component/template-only';

export interface TioFooterSignature {
  Element: HTMLDivElement;
}

const TioFooter: TOC<TioFooterSignature> = <template>
  <footer class="mt-20 mb-8 text-gray-500 px-5">
    <div class="grid grid-cols-2 lg:grid-cols-3">
      <div>
        <p class="tio-text-heading text-gray-800 mb-4">Tuition.io</p>
        <div class="mb-2">
          <a href="https://www.tuition.io/about" target="_blank" rel="noopener noreferrer">About Us</a>
        </div>
        <div class="mb-2">
          <a href="https://www.tuition.io/blog" target="_blank" rel="noopener noreferrer">Blog</a>
        </div>
        <div class="mb-2">
          <a href="https://www.tuition.io/media" target="_blank" rel="noopener noreferrer">Press</a>
        </div>
        <div class="mb-2">
          <a
            href="https://www.tuition.io/terms-of-use"
            target="_blank"
            rel="noopener noreferrer"
          >Terms of Service</a>
        </div>
        <div class="mb-2">
          <a
            href="https://www.tuition.io/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
          >Privacy Policy</a>
        </div>
      </div>
      <div>
        <p class="tio-text-heading text-gray-800 mb-4">Tech Support</p>
        <div class="mb-2">
          <span>
            Email us:
            <a href="mailto:support@tuition.io">support@tuition.io</a>
          </span>
        </div>
        {{! Disable call us per support request.
          <div class="mb-2">
          <span>
            Call us:
            <a href="tel:+1 (855) 353-9395">+1 (855) 353-9395</a>
          </span>
        </div>
        }}
      </div>
      {{! Keeps other cols shifted to left }}
      <div></div>
    </div>
  </footer>
</template>;

export default TioFooter;
